// WorkspaceIcon.js — a built-in app's icon (utils/workspace/workspaceIcons.js)
// at any size, in the surrounding text colour.
import { WORKSPACE_ICONS } from '../../utils/workspace/workspaceIcons';

export default function WorkspaceIcon({ id, size = 16, style, className }) {
  const body = WORKSPACE_ICONS[id];
  if (!body) return null;
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      style={{ display: 'inline-block', flex: 'none', verticalAlign: 'middle', ...style }}
      // Static, trusted markup from the icon set — nothing user-supplied.
      dangerouslySetInnerHTML={{ __html: body }}
    />
  );
}
